import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  GridLegacy as Grid,
} from '@mui/material';
import SnapshotGrid from './Snapshot/SnapshotGrid';

function Snapshot({
  className = '',
  mediaFormat = 'audio',
  playlists = [],
  mixes = [],
  messageBlocks = [],
  interruptions = [],
  loops = [],
  disabled = false,
  onClickDay = () => {},
}) {
  return (
    <div className={classNames('Snapshot', className)}>
      <Grid
        className="row extra-space"
        spacing={2}
        container
      >
        <Grid
          className="details-title"
          xs={6}
          item
        >
          Snapshot
        </Grid>
      </Grid>

      <Grid
        className="row"
        spacing={2}
        container
      >
        <Grid
          xs={12}
          item
        >
          <SnapshotGrid
            mediaFormat={mediaFormat}
            playlists={playlists}
            mixes={mixes}
            messageBlocks={messageBlocks}
            interruptions={interruptions}
            loops={loops}
            disabled={disabled}
            onClickDay={onClickDay}
          />
        </Grid>
      </Grid>
    </div>
  );
}

Snapshot.propTypes = {
  className: PropTypes.string,
  mediaFormat: PropTypes.oneOf([
    'audio',
    'visual',
  ]),
  playlists: PropTypes.arrayOf(PropTypes.object),
  mixes: PropTypes.arrayOf(PropTypes.object),
  messageBlocks: PropTypes.arrayOf(PropTypes.object),
  interruptions: PropTypes.arrayOf(PropTypes.object),
  loops: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  onClickDay: PropTypes.func,
};

export default Snapshot;
